import { schema } from 'normalizr';
import { CALL_API } from '../middleware/api';

// ACTIONS

export const FETCH_REQUEST = 'courierDevice/FETCH_REQUEST';
export const FETCH_SUCCESS = 'courierDevice/FETCH_SUCCESS';
export const FETCH_ERROR = 'courierDevice/FETCH_ERROR';

export const SINGLE_FETCH_REQUEST = 'courierDevice/SINGLE_FETCH_REQUEST';
export const SINGLE_FETCH_SUCCESS = 'courierDevice/SINGLE_FETCH_SUCCESS';
export const SINGLE_FETCH_ERROR = 'courierDevice/SINGLE_FETCH_ERROR';

export const UNLOAD_CURRENT = 'courierDevice/UNLOAD_CURRENT';

export const CREATE_REQUEST = 'courierDevice/CREATE_REQUEST';
export const CREATE_SUCCESS = 'courierDevice/CREATE_SUCCESS';
export const CREATE_ERROR = 'courierDevice/CREATE_ERROR';

export const DELETE_REQUEST = 'courierDevice/DELETE_REQUEST';
export const DELETE_SUCCESS = 'courierDevice/DELETE_SUCCESS';
export const DELETE_ERROR = 'courierDevice/DELETE_ERROR';

export const MODIFY_REQUEST = 'courierDevice/MODIFY_REQUEST';
export const MODIFY_SUCCESS = 'courierDevice/MODIFY_SUCCESS';
export const MODIFY_ERROR = 'courierDevice/MODIFY_ERROR';

// REDUCER
export default function reducer(
  state = {
    masterLocations: null,
    entities: null,
    result: [],
    current: null,
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case FETCH_REQUEST:
    case SINGLE_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: false,
        entities: action.payload.entities.courierDevice,
        result: action.payload.result,
      };

    case SINGLE_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        current: action.payload,
      };

    case MODIFY_SUCCESS:
    case CREATE_SUCCESS:
      return {
        ...state,
        entities: { ...state.entities, [action.payload.id]: action.payload },
      };

    case FETCH_ERROR:
    case SINGLE_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };

    case UNLOAD_CURRENT:
      return {
        ...state,
        current: null,
      };
    case DELETE_SUCCESS:
      const newEntities = { ...state.entities };
      delete newEntities[action.payload.id];
      return {
        ...state,
        entities: newEntities,
      };
    default:
      return state;
  }
}

// Schemas

const courierSchema = new schema.Entity('courierDevice');

// Operations

export function fetchCourierDevices() {
  return {
    [CALL_API]: {
      types: [FETCH_REQUEST, FETCH_SUCCESS, FETCH_ERROR],
      promise: (httpClient) => httpClient.post('/masterCourier'),
      schema: { data: [courierSchema] },
    },
  };
}

export function fetchCourierDevice(id) {
  return function (dispatch, getState) {
    const courierDeviceState = getState().courierDevice;

    if (courierDeviceState.entities && id in courierDeviceState.entities) {
      // courier already exists in store
      dispatch({
        type: SINGLE_FETCH_SUCCESS,
        payload: courierDeviceState.entities[id],
      });
    } else {
      dispatch({
        [CALL_API]: {
          types: [
            SINGLE_FETCH_REQUEST,
            SINGLE_FETCH_SUCCESS,
            SINGLE_FETCH_ERROR,
          ],
          promise: (httpClient) => httpClient.get(`/masterCourier/${id}`),
        },
      });
    }
  };
}

export function unloadCurrent() {
  return function (dispatch) {
    dispatch({ type: UNLOAD_CURRENT });
  };
}

export function modifyCourierDevice({
  courierDevice,
  onSuccess,
  successMessage,
  errorMessage,
}) {
  return {
    [CALL_API]: {
      types: [MODIFY_REQUEST, MODIFY_SUCCESS, MODIFY_ERROR],
      promise: (httpClient) =>
        httpClient.post('/masterCourier/modify', courierDevice),
      successMessage: successMessage || 'Courier address successfully modified',
      errorMessage: errorMessage || 'There was a problem updating the address',
      onSuccess,
    },
  };
}

export function createCourierDevice({
  courierDevice,
  successMessage = 'Courier master location successfully created',
  errorMessage = 'There was a problem deleting the courier master location',
}) {
  return {
    [CALL_API]: {
      types: [CREATE_REQUEST, CREATE_SUCCESS, CREATE_ERROR],
      promise: (httpClient) =>
        httpClient.post('/masterCourier/modify', courierDevice),
      successMessage,
      errorMessage,
    },
  };
}

export function deleteCourierDevice({
  id,
  successMessage,
  errorMessage,
  onSuccess,
}) {
  return {
    [CALL_API]: {
      types: [DELETE_REQUEST, DELETE_SUCCESS, DELETE_ERROR],
      promise: (httpClient) => httpClient.delete(`/masterCourier/${id}/delete`),
      successMessage: successMessage || 'Courier address successfully deleted',
      errorMessage: errorMessage || 'There was a problem deleting the courier',
      onSuccess: onSuccess || (() => null),
    },
  };
}

//! this is the only one we're using atm, to update any added or deleted devices
export function updateCourierDevices({
  courierId,
  masterIds,
  successMessage,
  errorMessage,
}) {
  return {
    [CALL_API]: {
      types: [DELETE_REQUEST, DELETE_SUCCESS, DELETE_ERROR],
      promise: (httpClient) =>
        httpClient.put(`/courier/masterCourier/update`, {
          courierId,
          masterIds,
        }),
      successMessage: successMessage || 'Courier devices successfully updated',
      errorMessage:
        errorMessage || 'There was a problem updating the courier devices',
    },
  };
}
